<template>
    <div class="main-div">
        <AdvisoriesToolTip />
        <div class="title-div">
            <span>No Advisories Found</span>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useDynamicDialog } from '~/composables/dynamic-dialog';
import { ModalNames } from '~/types/modals';
import AdvisoriesToolTip from './AdvisoriesToolTip.vue';

    function openModal() {
        useDynamicDialog(ModalNames.SUBMIT_RESEARCH_REQUEST);
    }
</script>
<style lang="scss" scoped>
.main-div {
    @apply flex flex-col justify-start items-center pb-5 px-6 pt-10 gap-10;
}
.title-div {
    @apply flex flex-col items-center gap-1 self-stretch;

    span {
        @apply self-stretch text-gray-900 text-center font-semibold text-base leading-6 font-inter;
    }
    p {
        @apply text-gray-600 text-center text-sm font-normal leading-5 font-inter max-w-sm mb-3 ;
    }
}
</style>